// Date Utilities
// ==============

class Dates {
    // Returns an ISO formatted date string ('2023-04-07') if 'date' is truthy, otherwise empty string.
    // The 'date' parameter can be: date string / date object / integer value.
    static getDateString(date) {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
        }
        return '';
    }

    // Returns a Date object if the 'date' parameter is truthy, otherwise undefined.
    // The 'date' parameter can be: date string / date object / integer value.
    static getDate(date) {
        return (date) ? new Date(date) : undefined;
    }

    // Returns the day of the week according for the first day of the week.
    static getDay(date, firstDay) {
        const day = date.getDay() - firstDay;
        return (day >= 0) ? day : day + 7;
    }

    // static getDiffDays(date1, date2) {
    //     return Math.floor(new Date(date1 - date2) / 86400000) + 1;
    // }

    // Returns the day of the week index according for the first day of the week.
    static getDayIndex(index, firstDay) {
        const i = index + firstDay;
        return (i < 7) ? i : i - 7;
    }
}

export default Dates;
